import { datadogRum } from '@datadog/browser-rum';

// eslint-disable-next-line no-underscore-dangle
declare const __ID_CAPTURE_VERSION__: string;

const RUM_CONTEXT_PREFIX = 'id_capture';
const DATADOG_RUM_APPLICATION_ID = '46b74509-449d-4308-a989-4e9dcefca52f';
const DATADOG_RUM_CLIENT_TOKEN = 'pubdb42ee1789c1154bc35e3e6f8d39570f';

let rumInitialized = false;

function ensureRumInitialized(): void {
  if (rumInitialized) {
    return;
  }
  rumInitialized = true;

  try {
    datadogRum.init({
      applicationId: DATADOG_RUM_APPLICATION_ID,
      clientToken: DATADOG_RUM_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: 'id-capture',
      version: __ID_CAPTURE_VERSION__,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      defaultPrivacyLevel: 'mask-user-input',
      startSessionReplayRecordingManually: true,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
    });
  } catch {
    rumInitialized = false;
  }
}

/**
 * Report an ID capture custom action to Datadog RUM.
 */
export function addIdCaptureRumAction(
  name: string,
  context?: Record<string, string | number | boolean | undefined>,
): void {
  try {
    ensureRumInitialized();
    datadogRum.addAction(name, {
      ...context,
      source: RUM_CONTEXT_PREFIX,
    });
  } catch {
    // ignore RUM failures
  }
}

/**
 * Report an ID capture error to Datadog RUM.
 */
export function addIdCaptureRumError(
  error: Error | unknown,
  context?: Record<string, string | number | boolean | undefined>,
): void {
  try {
    ensureRumInitialized();
    const err = error instanceof Error ? error : new Error(String(error));
    datadogRum.addError(err, {
      ...context,
      source: RUM_CONTEXT_PREFIX,
    });
  } catch {
    // ignore RUM failures
  }
}
